<template>
  <select
    :id="id"
    :name="name"
    class="form-control form-control--select"
    :class="className"
    :tabindex="tabindex"
    @change="onChangeItem"
  >
    <template v-if="hasPlaceholder">
      <option value>{{ placeholder }}</option>
    </template>
    <template v-for="item in items[type]">
      <option :value="item.id" :selected="isSelectedItem(item.id)">{{ item.title }}</option>
    </template>
  </select>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    },
    tabindex: {
      type: [String, Number],
      default: ""
    },
    type: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      items: this.$helpers.layertypes
    };
  },
  computed: {
    hasPlaceholder: function() {
      return this.placeholder !== "";
    }
  },
  watch: {
    placementType: function() {
      this.onUpdateDefaultValue();
    }
  },
  methods: {
    onSelectItem: function(id) {
      this.$emit("input", id);
      this.$emit("change", this.getItemById(id));
    },
    onChangeItem: function(event) {
      this.onSelectItem(event.currentTarget.value);
    },
    isSelectedItem: function(id) {
      return this.value === id;
    },
    getItemById: function(id) {
      var output = null;

      this.items[this.type].forEach(
        function(item) {
          if (item.id === id) {
            output = item;
          }
        }.bind(this)
      );

      return output;
    }
  }
};
</script>